export const MIN_GEORECENCY_DAYS = 3;
export const MAX_GEORECENCY_DAYS = 30;
// Matches the server's bounds (madserver madsql/geo.go MinRadius / MaxRadius).
export const MIN_GEO_CIRCLE_RADIUS = 30;
export const MAX_GEO_CIRCLE_RADIUS = 10000;
export const GEO_CONFIRMATION_MESSAGES = {
    confirmedRegionalRestrictions: "You must confirm regional restrictions compliance for geofence targeting.",
    confirmedSensitiveCategories: "You must confirm sensitive categories compliance for geofence targeting.",
    confirmedDeliveryImpact: "You must confirm delivery impact compliance for geofence targeting.",
    confirmedHealthcare: "You must confirm healthcare compliance for georecency targeting.",
    confirmedDataUsage: "You must confirm data usage terms for georecency targeting."
};
/**
 * Requires a compliance confirmation when there are circles.
 *
 * @param circles - The geofence or georecency circles the confirmation applies to
 * @param confirmed - Whether the user confirmed
 * @param message - Error message to return when unconfirmed
 */
export const validateGeoConfirmation = (circles, confirmed, message) => {
    if (!circles?.length) {
        return undefined;
    }
    return confirmed ? undefined : message;
};
/**
 * Requires a georecency lookback window between 3 and 30 days when there are georecency circles.
 *
 * @param circles - Georecency circles
 * @param duration - Lookback window in days
 */
export const validateGeorecencyDuration = (circles, duration) => {
    if (!circles?.length) {
        return undefined;
    }
    if (duration === null || duration === undefined) {
        return "Lookback Window is required when georecency locations are present.";
    }
    if (typeof duration !== "number" || isNaN(duration)) {
        return "Lookback Window must be a valid number.";
    }
    if (duration < MIN_GEORECENCY_DAYS || duration > MAX_GEORECENCY_DAYS) {
        return `Lookback Window must be between ${MIN_GEORECENCY_DAYS} and ${MAX_GEORECENCY_DAYS} days.`;
    }
    return undefined;
};
/**
 * Requires every circle's radius to be a whole number of meters between 30 and 10,000.
 * The server stores radius as an unsigned integer, so fractions and NaN can't be saved.
 *
 * @param circles - Geofence or georecency circles
 */
export const validateGeoCircleRadius = (circles) => {
    const outOfRange = circles?.some((circle) => !Number.isInteger(circle.radius) ||
        circle.radius < MIN_GEO_CIRCLE_RADIUS ||
        circle.radius > MAX_GEO_CIRCLE_RADIUS);
    return outOfRange
        ? `Location radius must be a whole number between ${MIN_GEO_CIRCLE_RADIUS} and ${MAX_GEO_CIRCLE_RADIUS.toLocaleString("en-US")} meters.`
        : undefined;
};
//# sourceMappingURL=geotargeting.js.map